export const mapGetToPostParams = params => {

    const arraySuffix = /\[[0-9]*]$/;
    const mappedParams = {};
    Object.entries(params)
        .forEach(([key, value]) => {

            if (arraySuffix.test(key)) {

                (mappedParams[key.replace(arraySuffix, '')] = mappedParams[key.replace(arraySuffix, '')] || []).push(value);
            } else {

                mappedParams[key] = value;
            }
        });

    return mappedParams;
};



// WEBPACK FOOTER //
// ./src/app/helpers/map-get-query-params.js